import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { breadcrumb, link, stat } from '../../layout/header/header.component';
import {
  ConfirmEventType,
  ConfirmationService,
  MenuItem,
  Message,
  MessageService,
} from 'primeng/api';
import { Table } from 'primeng/table';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
// import { ConnectableObservable } from 'rxjs';

import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { GlobalConstants } from 'src/app/services/global-constants';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-user-mmanagement',
  templateUrl: './user-mmanagement.component.html',
  styleUrls: ['./user-mmanagement.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class UserMmanagementComponent {
  skelition = true;

  @ViewChild('dt')
  dt!: Table;

  GlobalConstants = GlobalConstants;

  userFilters = UserFilters;

  messages: Message[] = [];
  translator: TranslatorPipe = new TranslatorPipe();

  //Filter Options
  genderOptions = [{ label: 'ذكر' }, { label: 'أنثى' }];
  managerOptions = [
    { label: this.translate('Managers') },
    { label: this.translate('Non Managers') },
  ];
  locationOptions: any[] = [];
  ouOptions: any[] = [];
  ouOptionsList: any[] = [];

  //Filter bindings
  filters: {
    ou: any,
    gender: any,
    manager: any,
    location: any
  } = {
      ou: null,
      gender: null,
      manager: null,
      location: null,
    }

  cols: any[] = [];
  exportColumns: { title: any; dataKey: any }[] = [];

  header = this.translate('User console');
  links: link[] = [
    {
      name: 'إضافة مستخدم',
      icon: 'pi pi-plus',
      link: '/admin/users/create',
      visible: this.permissionService.hasPermission('USER_MANAGEMENT', 'c'),
    },
    {
      name: 'إدارة الأدوار',
      icon: 'pi pi-verified',
      link: '/admin/users/roles',
      visible: this.permissionService.hasPermission('ROLE_MANAGEMENT', 'r'),
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('User console'), link: '/admin/users' },
  ];
  stats: stat[] = [];

  menuitems: MenuItem[] = [
    {
      label: this.translate('Activation Requests'),
      icon: 'pi pi-exclamation-triangle',
      command: (event) => {
        this.onActiveItemChange(event);
      },
    },
    {
      label: this.translate('User Informations'),
      icon: 'pi pi-check-circle',
      command: (event) => {
        this.onActiveItemChange(event);
      },
    },
    {
      label: this.translate('Deactivated Accounts'),
      icon: 'pi pi-times-circle',
      command: (event) => {
        this.onActiveItemChange(event);
      },
    },
  ];

  activeItem: MenuItem | any = {};
  activeItemLabel: string = '';

  users: any[] = [];
  data: any[] = [];
  allData: any[] = [];
  calucultedData: any[] = [];

  constructor(
    public dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    private ouService: OrgUnitsService
  ) { }

  getUsers = async () => {
    try {
      const res = await this.dataService.getData('user/all');
      if (res.error) {
        return;
      }

      //remove default user

      this.users = res.data.filter((e: any) => e.email != 'default@gmail.com');
      this.allData = this.users;

      this.constructData();
      this.skelition = false;
    } catch (error) {
      //console.log(error)
    }
  };

  handleFilter() {
    this.users = this.allData.filter((e) => {
      if (this.filters.gender) {
        if (e.gender != this.filters.gender.label) {
          return false;
        }
      }

      if (this.filters.location) {
        if (!!e.location && !!e.location._id && e.location._id != this.filters.location) {
          return false;
        }
      }

      if (this.filters.manager) {
        if (this.filters.manager.label == this.translate('Managers')) {
          if (!e.managerOus || (e.managerOus as Array<any>).length == 0) {
            return false;
          }
        } else if (this.filters.manager.label == this.translate('Non Managers')) {
          if (!!e.managerOus) {
            if ((e.managerOus as Array<any>).length > 0) {
              return false;
            }
          }
        }
      }

      if (this.filters.ou) {
        if (!(e.ou as Array<any>).some((f) => f._id == this.filters.ou._id)) {
          return false;
        }
      }

      return true;
    });
    this.constructData(true);
  }

  resetFilter() {
    this.users = this.allData;
    this.filters = {
      ou: null,
      gender: null,
      manager: null,
      location: null,
    };
    this.constructData();
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  calculateCounts = () => {
    const activateCount = this.users
      .filter((obj) => obj.active.status === true)
      .reduce((acc) => acc + 1, 0);
    const newRequests = this.users
      .filter(
        (obj) =>
          obj.active.status === false && obj.active.reason === 'NEW ACCOUNT'
      )
      .reduce((acc) => acc + 1, 0);
    const deactivateCount = this.users
      .filter(
        (obj) =>
          obj.active.status === false && obj.active.reason !== 'NEW ACCOUNT'
      )
      .reduce((acc) => acc + 1, 0);
    this.stats = [
      {
        name: 'طلبات جديدة',
        number: newRequests,
        icon: 'pi pi-exclamation-triangle',
      },
      {
        name: 'عدد المستخدمين النشطين ',
        number: activateCount,
        icon: 'pi pi-check-circle',
      },
      {
        name: this.translate('Deactivated Accounts'),
        number: deactivateCount,
        icon: 'pi pi-times-circle',
      },
    ];
  };

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  constructData = (fromFilter: boolean = false) => {
    this.data = [];
    if (!fromFilter) {
      this.ouOptions = [];
      this.locationOptions = [];
      this.ouOptionsList = [];
    }

    let dataHolder: any;

    if (this.activeItem.label === this.translate('Activation Requests')) {
      dataHolder = this.users.filter(
        (obj) =>
          obj.active.status === false && obj.active.reason === 'NEW ACCOUNT'
      );
    } else if (this.activeItem.label === this.translate('User Informations')) {
      dataHolder = this.users.filter((obj) => obj.active.status === true);
    } else {
      dataHolder = this.users.filter(
        (obj) =>
          obj.active.status === false && obj.active.reason != 'NEW ACCOUNT'
      );
    }
    dataHolder.forEach((item: any, index: number) => {
      if (!fromFilter) {
        let locationPresent = this.locationOptions
          ? this.locationOptions.find((e) => e.value == item.location?._id)
          : undefined;

        if (!locationPresent) {
          this.locationOptions.push({
            label: item.location?.name ?? item.location?.label,
            value: item.location?._id,
          });
        }

        (item.ou as Array<any>).forEach((e) => {
          let ouPresent = this.ouOptionsList.find((p) => e._id == p._id);

          if (!ouPresent) {
            if (e.type.tag == "Branches") {
              e.name = `${e.name} (${e.location.name})`
            }
            this.ouOptionsList.push(e);
            this.ouOptions.push(e);
          }
        });
      }

      // Activatated User Action Buttons
      if (this.activeItem.label === this.translate('User Informations')) {
        this.data.push({
          '#': { n: item._id, i: 'pi pi-angle-left' },
          'الاسم ': {
            n: `${item.name.first} ${item.name.middle} ${item.name.last}`,
            i: item.image_sq,
          },
          'عنوان البريد الإلكتروني': { n: `${item.email}`, i: item.image_sq },
          'رقم الهاتف المحمول': { n: `${item.phone}`, i: item.image_sq },
          الجنس: { n: `${item.gender}`, i: item.image_sq },
          'المدينة ': {
            n: item.location?.name
              ? item.location?.name
              : item.location?.label
                ? item.location?.label
                : 'غير معرف',
            i: 'pi pi-map-marker',
          },
          'الوحدة التنظيمية للمدير':
            (item.managerOus as Array<any>)?.length > 0
              ? {
                n: (item.managerOus as Array<any>)
                  ?.map((e) => e.name)
                  ?.join(', '),
              }
              : { n: '-' },
          'تاريخ الإنشاء': { n: item.createdAt?.substring(0, 10), i: item.image_sq },
          'تاريخ الاعتماد': { n: item?.approvedAt?.substring(0, 10), i: item.image_sq },
          'آخر تسجيل دخول': { n: item?.lastLogin ? new Date(item.lastLogin).toLocaleString(undefined, { hour12: false }).replace(',', '')  : '-', i: item.image_sq },
          Action: [
            {
              n: this.translate('Deactivated Accounts'),
              i: 'pi pi-user-minus',
              s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
            },
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
          ],
        });
      } else if (
        this.activeItem.label === this.translate('Activation Requests')
      ) {
        this.data.push({
          '#': { n: item._id, i: 'pi pi-angle-left' },
          'الاسم ': {
            n: `${item.name.first} ${item.name.middle} ${item.name.last}`,
            i: item.image_sq,
          },
          'عنوان البريد الإلكتروني': { n: `${item.email}`, i: item.image_sq },
          'رقم الهاتف المحمول': { n: `${item.phone}`, i: item.image_sq },
          الجنس: { n: `${item.gender}`, i: item.image_sq },
          'المدينة ': {
            n: item.location?.name
              ? item.location?.name
              : item.location?.label
                ? item.location?.label
                : 'غير معرف',
            i: 'pi pi-map-marker',
          },
          'الوحدة التنظيمية للمدير':
            (item.managerOus as Array<any>)?.length > 0
              ? {
                n: (item.managerOus as Array<any>)
                  ?.map((e) => e.name)
                  ?.join(', '),
              }
              : { n: '-' },
          'تاريخ الإنشاء': { n: item.createdAt?.substring(0, 10), i: item.image_sq },
          Action: [
            {
              n: 'Activate',
              i: 'pi pi-check-circle',
              s: 'p-button-rounded p-button-success p-button-text p-button-raised',
            },
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
            {
              n: this.translate('Deactivated Accounts'),
              i: 'pi pi-user-minus',
              s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
            },
          ],
        });
      } else {
        let reason = this.removeTags(item.active.reason);
        this.data.push({
          '#': { n: item._id, i: 'pi pi-angle-left' },
          الاسم: {
            n: `${item.name.first} ${item.name.middle} ${item.name.last}`,
            i: item.image_sq,
          },
          'عنوان البريد الإلكتروني': { n: `${item.email}`, i: item.image_sq },
          'رقم الهاتف المحمول': { n: `${item.phone}`, i: item.image_sq },
          الجنس: { n: `${item.gender}`, i: item.image_sq },
          'المدينة ': {
            n: item.location?.name
              ? item.location?.name
              : item.location?.label
                ? item.location?.label
                : 'غير معرف',
            i: 'pi pi-map-marker',
          },
          'الوحدة التنظيمية للمدير':
            (item.managerOus as Array<any>)?.length > 0
              ? {
                n: (item.managerOus as Array<any>)
                  ?.map((e) => e.name)
                  ?.join(', '),
              }
              : { n: '-' },
          'تاريخ الإنشاء': { n: item?.createdAt?.substring(0, 10), i: item.image_sq },
          'تاريخ الاعتماد': { n: item?.approvedAt?.substring(0, 10), i: item.image_sq },
          سبب: { n: reason },
          Action: [
            {
              n: 'Undo',
              i: 'pi pi-history',
              s: 'p-button-rounded p-button-text p-button-raised',
            },
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
          ],
        });
      }
    });
    if (!fromFilter && this.ouOptions?.length > 0) {
      this.ouOptions = this.ouService.convertToTreeNode(
        cloneDeep(this.ouOptionsList)
      );
    }
    this.calculateCounts();
  };




  removeTags(str: string): string | null {
    var div = document.createElement('div');
    div.innerHTML = str;
    return div.textContent;
  }

  actionCall($event: any) {
    switch ($event.action) {
      case 'Activate':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-check-square',
          action: () => this.activateUser($event.id),
        });
        break;
      case 'Update':
        this.editDialog = true;
        this.editData = this.users.find((user) => user._id === $event.id);
        break;
      case this.translate('Deactivated Accounts'):
        this.deactivateData = {
          _id: null,
          reason: null,
        };
        this.DeactivateDialog = true;
        this.deactivateData._id = $event.id;

        break;
      case 'Undo':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-check-circle',
          action: () => this.UndoDeactivateUser($event.id),
        });
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  // Edit User
  editDialog: boolean = false;
  editData: any;

  activateUser = async (id: string) => {
    try {
      const res = await this.dataService.postData(
        `user/activate/${id}`,
        {},
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          {
            severity: 'error',
            summary: this.translate('error'),
            detail: res.msg,
          },
        ];
        return;
      }
      this.messages = [
        {
          severity: 'success',
          summary: this.translate('success'),
          detail: res.msg,
        },
      ];
      this.users = this.users.map((e, i) => {
        if (e._id === id) {
          e.active.status = true;
          e.active.activateionDate = new Date();
        }
        return e;
      });
      this.constructData();
    } catch (error) {
      console.log(error);
    }
  };

  // Deactivate User
  DeactivateDialog: Boolean = false;
  deactivateData = {
    _id: null,
    reason: null,
  };
  reasonError: string | undefined;

  deactivateInit() {

    if (this.deactivateData.reason == undefined) {
      this.reasonError = 'السبب مطلوب';
      return;
    }
    this.reasonError = undefined;

    this.confirm({
      message: 'هل أنت متأكد من رغبتك بفعل هذا؟',
      header: 'رسالة التأكيد',
      icon: 'pi pi-check-square',
      action: () => this.deactivateUser(),
    });
  }

  userHolder: any;

  openModal($event: any) {
    this.userHolder = $event;
  }

  deactivateUser = async () => {
    try {
      const res = await this.dataService.postData(
        `user/deactivate`,
        this.deactivateData,
        'PUT',
        false
      );
      if (res.error) {
        this.reasonError = res.msg;
        return;
      }

      this.DeactivateDialog = false;
      this.messages = [
        {
          severity: 'success',
          summary: this.translate('success'),
          detail: res.msg,
        },
      ];
      // this.data = this.data.map((e, i) => {
      //   if (e.ID === this.deactivateData._id) {
      //     e.active.status = false;
      //     e.active.reason = this.deactivateData.reason;
      //   }
      //   return e;
      // });

      this.users = this.users.map((e, i) => {
        if (e._id === this.deactivateData._id) {
          e.active.status = false;
          e.active.reason = this.deactivateData.reason;
        }
        return e;
      });
      this.deactivateData = {
        _id: null,
        reason: null,
      };
      this.constructData();
    } catch (error) {
      console.log(error);
    }
  };

  UndoDeactivateUser = async (id: string) => {
    try {
      const res = await this.dataService.postData(
        `user/undo/deactivate/${id}`,
        {},
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          {
            severity: 'error',
            summary: this.translate('error'),
            detail: res.msg,
          },
        ];
        return;
      }
      this.messages = [
        {
          severity: 'success',
          summary: this.translate('success'),
          detail: res.msg,
        },
      ];
      // this.data = this.data.map((e, i) => {
      //   if (e.ID === id) {
      //     e.active.status = true;
      //     e.active.activationDate = new Date();
      //   }
      //   return e;
      // });
      this.users = this.users.map((e, i) => {
        if (e._id === id) {
          e.active.status = true;
          e.active.activationDate = new Date();
        }
        return e;
      });
      this.constructData();
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  ngOnInit() {
    this.activeItem = this.menuitems[0];
    this.getUsers();
  }

  onActiveItemChange(event: any) {
    this.activeItem = event.item;
    this.activeItemLabel = this.activeItem.label;
    this.constructData();
  }

  handleUpdatedUserData(updatedUser: any) {
    this.users.map((e, i) => {
      if (updatedUser._id == e._id) {
        this.users[i] = updatedUser;
      }
    });
    this.constructData();
  }
}

enum UserFilters {
  OU,
  GENDER,
  MANAGER,
  LOCATION,
}
